import { useMemo } from 'react';

import type { OfferingFull } from '../../../graphql';

export function useOfferingInstrument<
  TOffering extends Pick<OfferingFull, 'instruments' | 'pricingInstrumentId'>
>(offering: TOffering | null | undefined) {
  return useMemo(
    () =>
      offering?.instruments?.find(instrument => instrument.id === offering?.pricingInstrumentId),
    [offering]
  );
}
